import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, Loader2, Lock } from "lucide-react";
import Seo from "../components/Seo";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <Seo title="Admin Login" description="Administrator login" path="/admin/login" />
      <div className="glass-strong glass-reflect rounded-3xl p-8 w-full max-w-md">
        <div className="text-center mb-7">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br from-tara-gold to-tara-vermilion mb-4">
            <Flame className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-serif text-2xl font-bold gold-text">Admin Console</h1>
          <p className="text-sm text-tara-muted mt-1">TarapithTantrik.com</p>
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-xl bg-white/70 border border-tara-gold/25 px-4 py-3 text-sm text-tara-ink placeholder:text-tara-muted focus:outline-none focus:border-tara-gold"
            data-testid="admin-email-input"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-xl bg-white/70 border border-tara-gold/25 px-4 py-3 text-sm text-tara-ink placeholder:text-tara-muted focus:outline-none focus:border-tara-gold"
            data-testid="admin-password-input"
            required
          />
          {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-tara-gold to-tara-vermilion px-6 py-3 font-serif font-semibold text-white hover:brightness-110 transition disabled:opacity-70"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Lock className="h-5 w-5" />}
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
